import { useTitle } from '@vueuse/core';

import { APP_NAME } from '@/constants';

export const useBTitle = (title: string) => {
  useTitle(`${title} | ${APP_NAME}`);
};
